import _ from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import * as promoActions from '../../../store/actions/promoCode.action';
import errorMessages from '../../../utils/errorMessages';
import { checkRole, getCustomMonth, handleToast, roles } from '../../../utils/handler';
import { NumberInput, ReactPagination } from '../../components/CommonPages';
import { InitialPromoDetail } from '../../types/promoCode';
interface PromoCodeObject {
  UID: string;
  code: string;
  createdAt: string;
  createdUser?: any;
  isDelete: boolean;
  offerPercent: number;
  reUsableCount: number;
  validThru: Date;
  promoDetails: {
    UID: string;
    leadUID: string;
    promoUID: string;
    updatedAt: string;
    usedByUID: string;
  }[];
}

export const GeneratePromoCode: React.FC = (): JSX.Element => {
  const initialPromoDetails = {
    code: '',
    offerPercent: 100,
    reUsableCount: 1,
    validThru: moment(getCustomMonth(+1).toString()).utc().format(),
  };

  const [promoCodes, setPromoCodes] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [promoCodeDetails, setPromoCodeDetails] = useState<InitialPromoDetail>(initialPromoDetails);
  // const [filter, setFilter] = useState({ search: "", filterBy: "", filterType: "", sortBy: "createdAt", sortType: "DESC", limit: 10, page: 1 })
  const [pagination, setPagination] = useState({
    count: 0,
    limit: 10,
    page: 1,
    totalPages: 1,
  });
  useEffect(() => {
    getPromoList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const generatePromoCode = () => {
    promoActions.generatePromo(promoCodeDetails).then((response) => {
      if (response) {
        getPromoList();
        setFormSubmitted(false);
        setShowPopup(false);
        setPromoCodeDetails(initialPromoDetails);
        // handleToast({ message: successMessages.success }, 'success')
      }
    });
  };
  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setFormSubmitted(true);
    if (validateForm()) {
      generatePromoCode();
    }
  };
  const validateForm = () => {
    let isValid = true;
    let { code } = promoCodeDetails;
    if (!code || code.length < 6) {
      isValid = false;
      handleToast({ message: errorMessages.emptyPromoCode });
    }
    return isValid;
  };
  const getPromoList = (payload?: { page?: number; pageLimit?: number }) => {
    let page = payload?.page || pagination.page;
    let pageLimit = payload?.pageLimit || pagination.limit;
    promoActions.getPromoList({ page, pageLimit }).then((response) => {
      if (response) {
        setPromoCodes(response.promoCodeList);
        setPagination(response.pagination);
      }
    });
  };
  const deleteCode = async (promoId: string) => {
    if (window.confirm('Are you sure?')) {
      promoActions.deletePromo(promoId).then((response) => {
        if (response) {
          getPromoList();
        }
      });
    }
  };
  const handlePromoChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const name = e.target.name;
    let value: number | string = e.target.value;
    if (name === 'reUsableCount' && value) {
      value = Number(value);
    }
    setPromoCodeDetails({ ...promoCodeDetails, [name]: value });
  };
  const dateChange = (date: any) => {
    setPromoCodeDetails({ ...promoCodeDetails, validThru: moment(date).utc().format() });
  };
  const onPageChange = (pageNumber: number) => {
    setPagination((prev) => ({ ...prev, page: pageNumber }));
    getPromoList({ page: pageNumber });
  };
  return (
    <div>
      <div className=" no-header clearfix">
        <div className="d-flex justify-content-between py-1 flex-md-row flex-column align-items-center">
          <button
            className="float-right btn btn-primary"
            onClick={() => {
              setShowPopup(true);
            }}
          >
            <i className="fa fa-plus mr-2"></i>Generate Custom Promo
          </button>
          <button className="float-right btn btn-primary" onClick={() => generatePromoCode()}>
            <i className="fa fa-plus mr-2"></i>Generate Random Promo
          </button>
        </div>
        <div className="main-box-body clearfix">
          <div className="table-responsive">
            <table className="table text-nowrap user-list table text-center table table-striped table-hover ">
              <thead>
                <tr className="text-nowrap">
                  <th>Promo Code</th>
                  <th>Created At</th>
                  <th>Offer Percent</th>
                  <th>Valid Thru</th>
                  <th>Created By</th>
                  <th>Re-Usable Count</th>
                  <th>Used Count</th>
                  {checkRole(roles.admin) && <th>Action</th>}
                </tr>
              </thead>
              <tbody>
                {promoCodes &&
                  promoCodes.map((promoCode: PromoCodeObject, index: number) => (
                    <tr key={index}>
                      <td className="d-flex text-left">{promoCode.code}</td>
                      <td>{moment(promoCode.createdAt).isValid() ? moment(promoCode.createdAt).format('lll') : '-'}</td>
                      <td>{promoCode.offerPercent ? promoCode.offerPercent + '%' : '-'}</td>
                      <td>{moment(promoCode.validThru).isValid() ? moment(promoCode.validThru).format('lll') : '-'}</td>
                      <td>{promoCode.createdUser && !_.isEmpty(promoCode.createdUser) ? promoCode.createdUser.name : 'Auto'}</td>
                      <td>{promoCode.reUsableCount}</td>
                      <td>{promoCode?.promoDetails?.length}</td>
                      {checkRole(roles.admin) && (
                        <td className="action-column">
                          <i className="fa-solid fa-trash text-danger c-pointer" onClick={() => deleteCode(promoCode.UID)}></i>
                        </td>
                      )}
                    </tr>
                  ))}
              </tbody>
            </table>
            <ReactPagination currentPage={pagination.page} totalPages={pagination.totalPages} onPageChange={onPageChange} />
          </div>
          {showPopup && (
            <div className="popup ">
              <div className="popup-header">
                <span className="popup-name fs-21 f-bold">Generating Custom Promo Code</span>
                <i className="fa fa-times fa-lg text-danger float-right" onClick={() => setShowPopup(false)}></i>
              </div>
              <div className="mt-5">
                <form noValidate className={'row profile-form' + (formSubmitted ? ' was-validated' : ' ')} onSubmit={onSubmit}>
                  <div className="mb-3 col-6">
                    <label className="form-label">Custom Promo Code</label>
                    <input type="text" minLength={6} className="form-control" id="code" name="code" value={promoCodeDetails.code} onChange={handlePromoChange} required />
                    <div className="invalid-feedback">{errorMessages.emptyPromoCode}</div>
                  </div>
                  <div className="mb-3 col-6">
                    <label className="form-label">Choose Valid Until</label>
                    <ReactDatePicker selected={new Date(promoCodeDetails.validThru)} minDate={new Date()} onChange={dateChange} startDate={new Date()} isClearable={true} className="form-control" placeholderText="Valid Until"></ReactDatePicker>
                  </div>
                  <div className="mb-3 col-6">
                    <label className="form-label">Offer percentage</label>
                    <NumberInput disabled={true} name="offerPercent" value={promoCodeDetails.offerPercent} onChange={handlePromoChange} required />
                    {/* <input type="number" className="form-control" disabled={true} id="offerPercent" name="offerPercent" value={promoCodeDetails.offerPercent} onChange={handlePromoChange} required /> */}
                    <span className="fs-10">FYI: For now 100% free code only can be able to generate, Jeff</span>
                  </div>
                  <div className="mb-3 col-6">
                    <label className="form-label">Re-usable Count</label>
                    <NumberInput id="reUsableCount" name="reUsableCount" value={promoCodeDetails.reUsableCount} onChange={handlePromoChange} required />
                    {/* <input type="number" className="form-control" id="reUsableCount" name="reUsableCount" value={promoCodeDetails.reUsableCount} onChange={handlePromoChange} required /> */}
                  </div>

                  <div className="popup-footer">
                    <button type="submit" className=" btn btn-primary" onSubmit={onSubmit}>
                      Submit
                    </button>
                    <button type="button" className="ms-2 btn btn-danger" onClick={() => setShowPopup(false)}>
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
